import { render, staticRenderFns } from "./AnuenciaEmMassaV2.vue?vue&type=template&id=2c061bcd"
import script from "./AnuenciaEmMassaV2.vue?vue&type=script&lang=js"
export * from "./AnuenciaEmMassaV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c061bcd')) {
      api.createRecord('2c061bcd', component.options)
    } else {
      api.reload('2c061bcd', component.options)
    }
    module.hot.accept("./AnuenciaEmMassaV2.vue?vue&type=template&id=2c061bcd", function () {
      api.rerender('2c061bcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AnuenciaEmMassaV2.vue"
export default component.exports